import axios from "axios"
import * as utils from "@/Shared/utils"
import lodash from "lodash"
import {
  API_CONFIG_SERVICE_KEYVALUE,
  API_CONFIG_SERVICE_GROUPS
} from "./urls"

/**
 * Retrieve key value pairs for specific group
 * @param {string} groupName
 * @param {string} key
 * @returns {Promise}
 */
export function retrieveKeysList(groupName, key) {
  let configServiceURL = utils.getServerUrl() + API_CONFIG_SERVICE_KEYVALUE
  configServiceURL += "/" + groupName
  if (!lodash.isUndefined(key)) {
    configServiceURL += "/" + key
  }
  let keyValuePairsResponse = {}
  return axios
    .get(configServiceURL)
    .then((response) => {
      keyValuePairsResponse = response
      return keyValuePairsResponse
    })
    .catch((error) => {
      keyValuePairsResponse = {}
      return Promise.reject(error)
    })
}

/**
 * addKeyValuePair - Add new Key value pair
 * @param {string} groupName
 * @param {string} key
 * @param {object} configObject
 * @returns {Promise}
 */
export function addKeyValuePair(groupName, key, configValue, configType) {
  let configServiceURL = utils.getServerUrl() + API_CONFIG_SERVICE_KEYVALUE
  configServiceURL += "/" + groupName
  configServiceURL += "/" + key
  let keyValuePairResponse = {}
  let headers = {}
  if (configType === "string") {
    headers = {
      "Content-Type": "text/plain"
    }
  }

  return axios
    .post(configServiceURL, configValue, { headers: headers })
    .then((response) => {
      keyValuePairResponse = response
      return keyValuePairResponse
    })
    .catch((error) => {
      keyValuePairResponse = {}
      return Promise.reject(error)
    })
}

/**
 * updateKeyValuePair - Update key value pair details
 * @param {string} groupName
 * @param {string} key
 * @param {object} configObject
 * @param {string} configType
 * @returns {Promise}
 */
export function updateKeyValuePair(groupName, key, configValue, configType) {
  let configServiceURL = utils.getServerUrl() + API_CONFIG_SERVICE_KEYVALUE
  configServiceURL += "/" + groupName
  configServiceURL += "/" + key
  let keyValuePairResponse = {}
  let headers = {}
  if (configType === "string") {
    headers = {
      "Content-Type": "text/plain"
    }
  }
  return axios
    .put(configServiceURL, configValue, { headers: headers })
    .then((response) => {
      keyValuePairResponse = response
      return keyValuePairResponse
    })
    .catch((error) => {
      keyValuePairResponse = {}
      return Promise.reject(error)
    })
}

/**
 * deleteKeyValuePair - Delete key value pair details
 * @param {string} groupName
 * @param {string} key
 * @param {object} configObject
 * @returns {Promise}
 */
export function deleteKeyValuePair(groupName, key) {
  let configServiceURL = utils.getServerUrl() + API_CONFIG_SERVICE_KEYVALUE
  configServiceURL += "/" + groupName
  configServiceURL += "/" + key
  let keyValuePairResponse = {}
  return axios
    .delete(configServiceURL)
    .then((response) => {
      keyValuePairResponse = response
      return keyValuePairResponse
    })
    .catch((error) => {
      keyValuePairResponse = {}
      return Promise.reject(error)
    })
}
/**
 * Retrieve all the groups list
 * @param {*} queryObjectInput
 */
export function getGroups() {
  let configServiceURL = utils.getServerUrl() + API_CONFIG_SERVICE_GROUPS
  let groupsList = []
  return axios
    .get(configServiceURL)
    .then((response) => {
      groupsList = response.data.entries
      let groupObjectsArray = []
      lodash.forEach(groupsList, (value, index) => {
        // groupObjectsArray.push({ id: index, title: value })
        groupObjectsArray.push(value)
      })

      return groupObjectsArray
    })
    .catch((error) => {
      groupsList = []
      return Promise.reject(error)
    })
}



// WEBPACK FOOTER //
// ./src/ConfigService/ConfigServiceDataService.js